import { createTheme } from '@mui/material/styles'

const colors = {
    primary: '#218bcb',
    secondary: '#FFF',
    dangerous: '#c3272d',
    info: '#828282',
}

const theme = createTheme({
    palette: {
        primary: {
            main: colors.primary,
        },
        secondary: {
            main: colors.secondary,
        },
        info: {
            main: colors.info,
        },
    },
    typography: {
        h1: {
            fontSize: '24px',
        },
        h2: {
            fontSize: '1.125rem',
            lineHeight: '1.75rem',
        },
        body1: {
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
        },
        body2: {
            fontSize: '0.775rem',
        },
    },
})

export { theme, colors }
